export default __webpack_public_path__ + "static/media/19679487_173311929875261_6375181824724424521_o.04f69956.png";